import React from 'react';

import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

export const Loading = () => {
    return (
        <div style={{ flexGrow: 1 }}>
            <Grid 
                container 
                style={{ height: '10vh' }} 
                direction="row" 
                justifyContent="center" 
                alignItems='center'
            >
                <CircularProgress size={30}  />
            </Grid>
        </div>
    )
}

export default Loading;